// extracted by mini-css-extract-plugin
export default {"cardTitle":"VendorDetails_cardTitle__bsByY","card":"VendorDetails_card__wgGSz"};